import { render, staticRenderFns } from "./MenuTitle.vue?vue&type=template&id=c684444e&"
import script from "./MenuTitle.vue?vue&type=script&lang=js&"
export * from "./MenuTitle.vue?vue&type=script&lang=js&"
import style0 from "./MenuTitle.vue?vue&type=style&index=0&id=c684444e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports